define('models/member/supervisor',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
], function(
    _, Backbone, U,
    // services
    API
) {

    var MSupervisor = Backbone.Epoxy.Model.extend({
        idAttribute: '_id',

        computeds: {
            full: {
                deps: ["picture"],
                get: function(picture) {
                    return picture ? picture.full : "assets/images/default-profile-pic-thumbnail.jpg";
                }
            },
            name: {
                deps: ["firstname", "lastname"],
                get: function(firstname, lastname) {
                    return firstname + " " + lastname;
                }
            },
        },
    });

    // Return the model for the module
    return MSupervisor;
});

